import { render } from "./Gpucalc.vue?vue&type=template&id=b627eaca&scoped=true&ts=true"
import script from "./Gpucalc.vue?vue&type=script&lang=ts"
export * from "./Gpucalc.vue?vue&type=script&lang=ts"

import "./Gpucalc.vue?vue&type=style&index=0&id=b627eaca&lang=less&scoped=true"

import exportComponent from "/Users/jiangshanwen/workspace/website-3.0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b627eaca"]])

export default __exports__